import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  MatCheckboxModule, MatDialogModule, MatInputModule, MatButtonModule, MatTabsModule, MatToolbarModule, MatListModule,
  MatCardModule, MatStepperModule, MatMenuModule, MatSidenavModule, MatIconModule, MatSelectModule, MatExpansionModule, MatSnackBarModule,
  MatSlideToggleModule,
  MatTooltipModule
} from '@angular/material';

@NgModule({
  exports: [
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatTabsModule,
    MatToolbarModule,
    MatListModule,
    MatCardModule,
    MatStepperModule,
    MatSelectModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    FlexLayoutModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatTooltipModule
  ]
})
export class MatComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/modules/mat-components/mat-components.module.ts